import { useTranslation } from "react-i18next";
import { H3 } from "components/Typography/text.styled";
import { FontFamily} from "config/font";
import { OrganizationalStructureOverview } from "./organizationalStructureOverview.component";
import { useOrganizationalStructureStore } from "web-apps/company/stores/organizationalStructureStore/organizationalStructureStore";
import { CreateWorkerModal } from "./createWorkerModal.component";
import { useState } from "react";
import { EmptyStructure } from "./emptyStructure.component";
import { ButtonComponent } from "../general/button/button.component";

export const OrganizationalStructure = () => {
  const { t } = useTranslation();
  const [state] = useOrganizationalStructureStore();
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <>
      <H3
        fontFamily={FontFamily.MontserratSemiBold}
        style={{ marginBottom: 0 }}
      >
        {t("OrganizationalStructure.Organization")}
      </H3>
      <ButtonComponent
        size={"small"}
        onClick={() => setShowCreateModal(true)}
        action={true}
        marginTop={10}
        marginBottom={20}
        alignRight={true}
        marginRight={20}
      >
        {t("OrganizationalStructure.CreateWorker")}
      </ButtonComponent>
      {!state.structure ? (
        <EmptyStructure type={"Entity"} />
      ) : (
        <OrganizationalStructureOverview entities={state.structure.entities} />
      )}
      <CreateWorkerModal
        showCreateModal={showCreateModal}
        setShowCreateModal={setShowCreateModal}
      />
    </>
  );
};
